import { Box, Button, Tooltip, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import DrillDownAccordion from "./DrillDownAccordion";
import InfoIcon from "@mui/icons-material/Info";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import EditIcon from "@mui/icons-material/Edit";
import { saveAs } from "file-saver";
import { theme as colorTheme, palette } from "../../../../Convoze.theme";
import RefreshIcon from "@mui/icons-material/Refresh";
import CircularProgress from "@mui/material/CircularProgress";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import apiEndPointsConfig from "../../../../services/apiEndPoints";
import axiosInstance from "../../../../services/axiosInterceptors";
import html2pdf from "html2pdf.js";
import { generateHTMLForPDF } from "./PdfTemplate";


// Converts qaParameters to flat CSV structure
function generateCSVFromQAParameters(categorized) {

  let csv =
    "Category,Parameter Name,Parameter Index,Criticality,SubParameter,Issue Flagged,Reason\n";

  const addRows = (categoryName, items) => {
    items.forEach((item) => {
      item.subParameters.forEach((sub) => {
        csv += `"${categoryName}","${item.name}","${item.parameterIndex}","${item.criticality}","${sub.parameter}","${sub.issueFlagged}","${sub.reason}"\n`;
      });
    });
  };

  addRows("Non-Critical", categorized.nonCritical);
  addRows("Critical", categorized.critical);
  addRows("Most-Critical", categorized.mostCritical);

  return csv;
}

// --- Utility: trigger CSV download ---
function exportToCSV(csvContent, fileName) {
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

// const sortQAParameters = (obj) =>
//   Object.fromEntries(
//     Object.entries(obj).sort(
//       ([, a], [, b]) => a.parameterIndex - b.parameterIndex
//     )
const QaParameters = ({ qaParameters, Id, interactionData }) => {
  console.log(qaParameters, "qaParajer");
  const navigate = useNavigate();
  const [reprocessing, setReprocessing] = useState(false);
  const isDevConvoze = ["dev", "local"].includes(
    process.env.REACT_APP_CONVOZE_ENV_TYPE
  );

  const handleExportPDF = () => {
    const htmlString = generateHTMLForPDF(qaParameters, interactionData, Id);
    
    // Wrap in a widescreen container to match A4 landscape dimensions perfectly
    const landscapeHtml = `<div style="width: 1020px; box-sizing: border-box; background-color: #ffffff; padding: 0; margin: 0;">${htmlString}</div>`;

    const opt = {
      margin:       [10, 10],
      filename:     `QA-Evaluation-Report-${Id}.pdf`,
      image:        { type: "jpeg", quality: 0.98 },
      html2canvas:  { 
        scale: 3, 
        useCORS: true,
        logging: false,
        letterRendering: true
      },
      jsPDF:        { unit: "mm", format: "a4", orientation: "landscape" },
      pagebreak:    { mode: ["css", "legacy"] }
    };

    html2pdf()
      .set(opt)
      .from(landscapeHtml)
      .save()
      .catch((error) => {
        console.error("PDF Export Error:", error);
      });
  };

  // --- Utility: categorize and sort ---
  // function categorizeAndSortByCriticality(data) {
  //   const result = {
  //     nonCritical: [],
  //     critical: [],
  //     mostCritical: [],
  //   };

  //   if (!data || typeof data !== "object" || Array.isArray(data)) {
  //   return result;
  // }

  //   for (const [key, value] of Object.entries(data)) {
  //     const crit = value.criticality?.toLowerCase();
  //     const item = { name: key, ...value };

  //     if (crit === "noncritical") result.nonCritical.push(item);
  //     else if (crit === "critical") result.critical.push(item);
  //     else if (crit === "mostcritical") result.mostCritical.push(item);
  //   }

  //   const sortByIndex = (a, b) =>
  //     Number(a.parameterIndex) - Number(b.parameterIndex);
  //   result.nonCritical.sort(sortByIndex);
  //   result.critical.sort(sortByIndex);
  //   result.mostCritical.sort(sortByIndex);

  //   return result;
  // }
  const sortQAParameters = (obj) => {
    if (!obj || typeof obj !== "object" || Array.isArray(obj)) {
      return {};
    }

    return Object.fromEntries(
      Object.entries(obj).sort(
        ([, a], [, b]) =>
          Number(a?.parameterIndex || 0) - Number(b?.parameterIndex || 0)
      )
    );
  };

  function categorizeAndSortByCriticality(data) {
    const result = {
      nonCritical: [],
      critical: [],
      mostCritical: [],
    };

    if (!data || typeof data !== "object" || Array.isArray(data)) {
      return result;
    }

    for (const [key, value] of Object.entries(data)) {
      const crit = value?.criticality?.toLowerCase();
      const item = { name: key, ...value };

      if (crit === "noncritical") result.nonCritical.push(item);
      else if (crit === "critical") result.critical.push(item);
      else if (crit === "mostcritical") result.mostCritical.push(item);
    }

    const sortByIndex = (a, b) =>
      Number(a?.parameterIndex || 0) - Number(b?.parameterIndex || 0);

    result.nonCritical.sort(sortByIndex);
    result.critical.sort(sortByIndex);
    result.mostCritical.sort(sortByIndex);

    return result;
  }
  // Example usage:
  const categorized = categorizeAndSortByCriticality(qaParameters);
  console.log(categorized.nonCritical); // Sorted NonCritical items
  console.log(categorized.critical); // Sorted Critical items
  console.log(categorized.mostCritical); // Sorted MostCritical items

  const token = localStorage.getItem("token");
  const decodedToken = token ? jwtDecode(token) : "";
  const isCurator = decodedToken?.userRole === "Curator";


  const reprocessQaParameter = async () => {
    try {
      setReprocessing(true);
      const res = await axiosInstance.get(
        `${apiEndPointsConfig?.ReprocessQaparameter}/${Id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log("Reprocess triggered:", res.data);
      // Optional: show toast / snackbar
      // enqueueSnackbar("QA Parameters reprocessing started", { variant: "success" });

    } catch (error) {
      console.error("reprocessQaParameter fetch error:", error);

      // Optional: error toast
      // enqueueSnackbar("Failed to reprocess QA Parameters", { variant: "error" });
    } finally {
      setReprocessing(false);
    }
  };


  return (
    <>
      <Box>
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Typography
            variant="h5"
            component="h1"
            fontWeight="bold"
            sx={{ display: "flex", alignItems: "center", gap: 1 }}
          >
            QA Parameters
            <Tooltip
              title="Below are the listed parameters for call adhrance with the process and policy."
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <InfoIcon
                sx={{
                  fontSize: 18,
                  color: "grey",
                }}
              />
            </Tooltip>
          </Typography>
          <Box sx={{ gap: "1rem", display: "flex", flexWrap: "wrap" }}>
            {isCurator && (
              <Button
                variant="outlined"
                startIcon={<EditIcon />}
                onClick={() => navigate(`/user/qa-edit/${Id}`)}
                sx={{
                  textTransform: "none",
                  borderColor: "#ccc",
                  color: "#fff",
                  bgcolor: "#118D57",
                  "&:hover": {
                    backgroundColor: "#0e7a4a",
                  },
                }}
              >
                Edit QA
              </Button>
            )}
            <Button
              variant="outlined"
              startIcon={<FileDownloadIcon />}
              onClick={() =>
                exportToCSV(
                  generateCSVFromQAParameters(categorized),
                  "qa-parameters.csv"
                )
              }
              sx={{
                textTransform: "none",
                borderColor: "#ccc",
                color: "#fff",
                bgcolor: "#7635DD",
                "&:hover": {
                  backgroundColor: "#6b23e0ff",
                },
              }}
            >
              Export CSV
            </Button>
            <Button
              variant="outlined"
              startIcon={<FileDownloadIcon />}
              onClick={handleExportPDF}
              sx={{
                textTransform: "none",
                borderColor: "#ccc",
                color: "#fff",
                bgcolor: "#118D57",
                "&:hover": {
                  backgroundColor: "#0e7a4a",
                },
              }}
            >
              Export PDF
            </Button>
            {isCurator && (
              <Button
                variant="outlined"
                startIcon={
                  reprocessing ? (
                    <CircularProgress size={16} color="inherit" />
                  ) : (
                    <RefreshIcon />
                  )
                }
                disabled={reprocessing}
                onClick={reprocessQaParameter}
                sx={{
                  textTransform: "none",
                  borderColor: "#ccc",
                  color: "#fff",
                  bgcolor: "#FF9800",
                  "&:hover": {
                    backgroundColor: "#FB8C00",
                  },
                }}
              >
                {reprocessing ? "Reprocessing..." : "Reprocess QA"}
              </Button>
            )}
          </Box>
        </Box>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
          In-depth analysis of customer sentiment, intent, and experience during
          this conversation.
        </Typography>
      </Box>
      <Box
        sx={{
          width: "100%",
        }}
      >
        {/* <DrillDownAccordion data={qaParameters} /> */}
        <DrillDownAccordion data={sortQAParameters(qaParameters)} Id={Id} />
      </Box>
    </>
  );
};

export default QaParameters;
